import { jsxs as d, jsx as s } from "react/jsx-runtime";
import { forwardRef as p } from "react";
import { c as _ } from "./index-SYE1cn5_.js";
import { L as h } from "./Label-DMBnN1_E.js";
import { I as x } from "./Input-DFqMEdAg.js";
import { T as F } from "./Text-D6i4LEWL.js";
const u = "_field_2t869_1", N = "_errorMessage_2t869_7", a = {
  field: u,
  errorMessage: N
}, w = p(function({
  id: e,
  label: o,
  className: i,
  required: t = !1,
  disabled: m,
  errorMessage: r,
  prependSlot: f,
  appendSlot: l,
  ...c
}, n) {
  return /* @__PURE__ */ d("div", { className: _(a.field, i), children: [
    o && /* @__PURE__ */ s(h, { htmlFor: e, required: t, children: o }),
    /* @__PURE__ */ s(
      x,
      {
        id: e,
        ref: n,
        required: t,
        disabled: m,
        isError: !!r,
        prependSlot: f,
        appendSlot: l,
        ...c
      }
    ),
    r && /* @__PURE__ */ s(F, { variant: "caption", className: a.errorMessage, children: r })
  ] });
});
export {
  w as F
};
